import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';

import CustomerStoriesContent from '../components/CustomerStories/CustomerStoriesContent';

const CustomerStories = () => {
  useEffect(() => {
    document.title = "Customer Stories | GoPaperless"
  })


  return (
    <>
        <NavbarTop/>
        <CustomerStoriesContent/>
        
    </>
  )
}

export default CustomerStories